module.exports = __webpack_public_path__ + "img/lansen.0e85224c.png";